function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#4FCEC8",
  cx: "20",
  cy: "20",
  r: "20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.194 8H12.198a1 1 0 00-1 1v22a1 1 0 001 1h16.604a1 1 0 001-1V14.657a2 2 0 00-.578-1.407l-4.609-4.657A2 2 0 0023.194 8zm1.066 1.366l4.19 4.234h-3.19a1 1 0 01-1-1V9.366zM11.99 30.2V9.8a1 1 0 011-1h10.479v4.6a1 1 0 001 1h4.541v15.8a1 1 0 01-1 1H12.99a1 1 0 01-1-1zm11.827-8.423a4.87 4.87 0 00.637-2.121 2.999 2.999 0 00-.308-1.472c-.361-.75-.982-1.173-1.582-1.58-.447-.305-.87-.592-1.17-1.003l-.053-.073c-.176-.241-.376-.514-.408-.744a.446.446 0 00-.466-.383.442.442 0 00-.409.444v7.951a2.515 2.515 0 00-1.318-.366c-1.212 0-2.198.8-2.198 1.785 0 .985.986 1.785 2.198 1.785 1.211 0 2.198-.8 2.198-1.785v-5.2c.66.256 1.74.908 2.038 2.431-.056.083-.108.172-.17.244a.45.45 0 00.04.629.433.433 0 00.62-.04c.117-.136.222-.295.322-.46a.28.28 0 00.03-.042z",
  fill: "#FFF"
}))));